/**
 * @description  Available rules when widget try to change its state
 */

export default Object.freeze({
  ONLY_SCHEDULE: 'ONLY_SCHEDULE', // change state only if schedule is opened
  SCHEDULE_AND_AGENT: 'SCHEDULE_AND_AGENT', // change state if schedule is opened AND agent is available
  NONE: 'NONE', // change state withou any check
})
